<template>
  <span>{{ value | currency }}</span>
</template>

<script>
export default {
  name: "CurrencyCell",
  props: {
    value: {
      type: Number
    },
  },
}
</script>

<style scoped>

</style>
